import { common } from '@tencent/ceiba-base-components';
import Vue from 'vue';

let loginManagerInstance = null;

const isApp = () => !!window.navigator.userAgent.match(/tgclub/i);
const isSafari = () => /^((?!chrome|android).)*safari/i.test(navigator.userAgent);

const checkAccountType = () => (common.tool.getCookie('acctype') === 'wx' ? 'wx' : 'qc');

const SAFARI_WX_APPID = 'wx5f930f997198dbd6';// safari下微信用游戏家公会

/**
 * @description 仅支持在safari浏览器可拉起微信授权登录场景
 */
function wxLoginSafari() {
  const urlTmp = `https://xinyue.qq.com/comm-htdocs/login/milosdk/wx_mobile_redirect.html?acctype=wx&appid=${SAFARI_WX_APPID}&s_url=${encodeURIComponent(location.href.replace(/(code=\w+[&|#|$]*)/g, '').replace(/[&|?]$/, ''))}`; // 去除code
  window.location.href = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=${SAFARI_WX_APPID}&redirect_uri=${encodeURIComponent(urlTmp)}&response_type=code&scope=snsapi_userinfo#wechat_redirect`;
}

function loginByQQ(loginManager) {
  loginManager.mobileLoginByQQConnect({
    appId: '101478665',
    redirectUri: 'https://xinyue.qq.com/comm-htdocs/login/qc_redirect.html',
    sUrl: location.href,
  });
  localStorage.curPlatform = 'qq';
}

function loginByWx(loginManager) {
  if (isSafari()) {
    wxLoginSafari();
  } else {
    loginManager.mobileLoginByWX({
      appId: isSafari() ? SAFARI_WX_APPID : 'wx5a3bbeac0d87c75a', // safari用游戏家公会,其他默认用心悦公众号
      scope: 'snsapi_userinfo', // 默认是 snsapi_base 静默授权，如果游戏无静默权限，就需要手动改成 snsapi_userinfo
      userinfoSpan: 'userinfo',
      forcePopup: true,
      snapShotTips: true,
      snapShotCustomTips: '我同意“本活动获取您的个人信息，仅用于该活动的查询、抽奖、领取、发货、签到等操作”',
    });
  }
  localStorage.curPlatform = 'wx';
}
export default {
  /**
   * 心悦登录特点
   * 游戏：只有手游，没有端游
   * 注销：APP里没有登出操作
   * 自动登录:QQ浏览器pt登录，微信则wx登录
   * 心悦APP内QQ默认用QC互联登录
   */
  initLogin: async () => new Promise((resolve) => {
    window.ams_login_avoid_conflict = true;
    console.log('tgclub initLogin begin');
    // 为了兼容qq客户端内打开,需要手动清除pt登录的cookie
    common.tool.clearCookie('uin');
    common.tool.clearCookie('skey');
    // window.iUseQQConnect = common.tool.getCookie('acctype') === 'qc' ? 1 : 0;
    // 因为midas只支持qc登录态,所以心悦先强制qc.
    window.iUseQQConnect = 1;
    loginManagerInstance = new Vue.prototype.$miloLoginManager({
      commonParams: {
        iUseQQConnect: window.iUseQQConnect,
        useAppLogin: ['tgclub'],
      },
      mobileParams: {
        oWXParams: {
          gameDomain: 'xinyue.qq.com',
          appId: isSafari() ? SAFARI_WX_APPID : 'wx5a3bbeac0d87c75a',
          scope: 'snsapi_userinfo',
        },
        oQQConnectParams: {
          appId: '101478665',
          redirectUri: 'https://xinyue.qq.com/comm-htdocs/login/qc_redirect.html',
          sUrl: location.href,
        },
      },
    });
    console.log('tgclub initLogin done instance=', loginManagerInstance);
    resolve();
  }),
  /**
   * 去登录操作
   * @param {登录方式} loginType
   */
  login: async (params = { loginType: 'qq' }) => {
    console.log('tgclub login');
    if (params.loginType === 'qq') loginByQQ(loginManagerInstance);
    if (params.loginType === 'wx') loginByWx(loginManagerInstance);
  },
  /**
   * 检查登录信息，返回是否登录+登录信息
   * @returns {
   *  "isLogin":true,
   *  "userInfo":{}
   * }
   */
  checkLogin: async () => await new Promise((resolve) => {
    console.log('loginManagerInstance', loginManagerInstance);
    if (location.href.indexOf('FLUSH_COOKIE=') > 0) {
      common.tool.clearAllCookie();
      let newHref = location.href;
      newHref = common.tool.delHrefParam('FLUSH_COOKIE', '', newHref);
      location.href = newHref;
    }
    loginManagerInstance.checkRealLogin().then((res) => {
      const { isLogin, userInfo } = res;
      if (userInfo) {
        userInfo.avatar = userInfo?.avatarUrl ?? userInfo?.formatUserInfo?.avatarUrl;
      }
      console.log('checkRealLogin  with $miloLoginManager userInfo =', userInfo);
      // 采用localStorage 保持登录的连续性 保持活动页面上一次保持登录的方式
      //
      let { curPlatform } = localStorage;
      console.log('checkRealLogin curPlatform from localStorage ', curPlatform);
      if (!curPlatform) {
        curPlatform = Vue.prototype.$platform.isWX ? 'wx' : 'qq';
      }
      if (isApp()) {
        curPlatform = checkAccountType();
      }
      console.log('checkRealLogin curPlatform ', curPlatform);
      resolve({
        isLogin,
        userInfo,
      });
    })
      .catch((err) => {
        console.info('CEIBA_PREVIOUS_COOKIE_CACHE', JSON.stringify({ cookie: document.cookie }));
        localStorage.setItem('CEIBA_PREVIOUS_COOKIE_CACHE', JSON.stringify({ cookie: document.cookie }));
        console.error('checkRealLogin Failed Code:', err.errCode);
        console.error('checkRealLogin Failed info:', err.errInfo);
        common.tool.clearAllCookie();
        resolve({
          isLogin: false,
          userInfo: {},
        });
      });
  }),
  /**
   * 登出操作
   */
  logout: async () => {
    await loginManagerInstance.logout().then((res) => {
      console.log('tgclub user logout res:', res);
      common.tool.clearAllCookie();
      localStorage.curPlatform = '';
    });
  },
};
